import { lazy } from 'react';

import * as Users from './users';
import * as Events from './event';
import * as Profile from './profile';
import * as Company from './company';
import * as Products from './products';
import * as Dashboard from './dashboard';
import * as Customers from './customers';
import * as Employees from './employees';
import * as Accounting from './accounting';
import * as Deals from './inventory/deals';
import * as EventReviews from './event-reviews';
import * as Category from './inventory/category';
import * as Storages from './inventory/storages';
import * as Notifications from './notifications';
import * as Suppliers from './inventory/suppliers';
import * as EventsCalendar from './events-calendar';
import * as Attributes from './inventory/attributes';
import * as CompanySettings from './company-settings';
import * as StockOrders from './inventory/stock-orders';
import * as DailyCounts from './inventory/daily-counts';
import * as EventOrders from './shipments/event-orders';
import * as InventoryProducts from './inventory/products';
import * as EventInventory from './inventory/event-inventory';
import * as StockTransfers from './inventory/stock-transfers';

const Reports = lazy(() => import('./reports'));
const Settings = lazy(() => import('./settings'));
const NotFound = lazy(() => import('./not-found'));
const Inventory = lazy(() => import('./inventory'));
const Shipments = lazy(() => import('./shipments'));
const Themes = lazy(() => import('./settings/themes'));
const Devices = lazy(() => import('./settings/devices'));
const CustomerCare = lazy(() => import('./customer-care'));
const CustomerCareReceipt = lazy(() => import('./customer-care/receipt'));
const AccountingCustomerCareReport = lazy(
  () => import('./customer-care/accounting-report')
);
const Carriers = lazy(() => import('./settings/carriers'));
const Shipping = lazy(() => import('./settings/shipping'));
const CreateShipping = lazy(() => import('./create-shipping'));
const Integrations = lazy(() => import('./settings/integrations'));
const ProductTypes = lazy(() => import('./settings/product-types'));
const EmployeeCompetition = lazy(() => import('./employee-competition'));
// PAYROLL DASHBOARD (plan §5): its own lazy chunk.
const Payroll = lazy(() => import('./payroll'));

export {
  Users,
  Deals,
  Events,
  Themes,
  Payroll,
  Profile,
  Reports,
  Devices,
  Company,
  Storages,
  Category,
  NotFound,
  Settings,
  Shipping,
  Products,
  Carriers,
  Suppliers,
  Inventory,
  Shipments,
  Employees,
  Dashboard,
  Customers,
  Attributes,
  Accounting,
  DailyCounts,
  StockOrders,
  EventOrders,
  EventReviews,
  ProductTypes,
  CustomerCare,
  Integrations,
  Notifications,
  CreateShipping,
  StockTransfers,
  EventsCalendar,
  EventInventory,
  CompanySettings,
  InventoryProducts,
  CustomerCareReceipt,
  EmployeeCompetition,
  AccountingCustomerCareReport,
};
